import { createFileRoute } from '@tanstack/react-router'

import { Agent } from '@/widgets/agent'

export const Route = createFileRoute('/_app/agents-hub/risk-scoring/$policyId')({
  component: RouteComponent,
})

export const RiskScoringPolicyRoute = Route

function RouteComponent() {
  return <Agent agentId="risk-scoring" />
}
